import { EnumItemDto } from "approot/global/models/common.model";
import { LoginDataService } from "./login.data.service";
import { ResourceLoader } from "webroot/static/src/common/js/resourceLoader";
import { LongWorkService } from "approot/global/providers/uikit.dialogs";

declare var angular: ng.IAngularStatic;

export class NsProductNameService {
	static localizeProductName(loadableLanguage: string) {
		angular.element(".lang__global")
			.removeClass()
			.addClass(`lang__global`)
			.addClass(`lang__global__${loadableLanguage}`);

		NsProductNameService.localizeTitle(loadableLanguage);
	}

	static localizeTitle(loadableLanguage: string) {
		// костыль, тут не получилось css
		let localizedTitle = angular.element(`.lang__${loadableLanguage} .logoline__headertext`).toArray().map(el => el.innerText).join(' ');
		let titleJQ = angular.element("title.lang__title");

		if (titleJQ.text() != localizedTitle && localizedTitle?.length > 0) {
			angular.element("title.lang__title").text(localizedTitle);
		}
	}
}

export class ChangeLanguageService {
	private resourceLoader: ResourceLoader;

	public langList: string[] = [];
	public defaultLanguage: string;
	public nowLanguage: string;
	public queryLanguage: string;
	public languages: EnumItemDto[];
	public pageLanguage: EnumItemDto;
	public pageLanguageLoaded: ng.IPromise<void>;

	/*@ngInject*/
	constructor(
		private loginDataService: LoginDataService,
		private $longWork: LongWorkService,
		private $cookies: any,
		private $q: ng.IQService,
		private $location: ng.ILocationService,
		private language: any,
	) {
		this.init();
	}

	private init() {
		const version = this.loginDataService.loginData?.viewData?.version || "3";

		this.$cookies.put("pageLng", this.$cookies.get('UserLanguage'));
		this.resourceLoader = new ResourceLoader((url) => url + `?ver=${version}`);
		this.pageLanguageLoaded = this.load();
	}

	private load() {
		let languageDataReady = this.loginDataService.loadViewData()
			.then(() => {
				let loginViewData = this.loginDataService.loginData.viewData;
				this.languages = angular.copy(loginViewData.languages);
				this.languages.forEach(lang => this.langList.push(lang.key))		
				this.queryLanguage = this.check(ChangeLanguageService.getQueryLanguage());
				this.nowLanguage = this.check(this.$cookies.get('UserLanguage'));
				this.defaultLanguage = this.check(loginViewData.defaultLanguage);
				const spare = (this.queryLanguage == null && this.nowLanguage == null && this.defaultLanguage == null) ? this.languages[0].key : null;
				this.pageLanguage = this.languages.find(lang => lang.key == (this.queryLanguage ?? this.nowLanguage ?? this.defaultLanguage ?? spare));

				NsProductNameService.localizeTitle(this.pageLanguage.key);
			});

		return this.$q.when(languageDataReady)
			.then(() => this.loadLanguage());
	}

	private check(str: string): string{
		return (this.langList.some(lang => lang === str)) ? str : null;
	}

	private loadLanguage() {
		let loadableLanguage = this.pageLanguage.key;

		NsProductNameService.localizeProductName(loadableLanguage);

		return this.$q.when(this.resourceLoader.loadScript(`/static/dist/lng/language_${loadableLanguage}.js`))
			.then(() => {
				var loadedLanguage = (<any>window).language;
				Object.assign(this.language, loadedLanguage);
			});
	}

	static getQueryLanguage() {
		let searchParams = new URLSearchParams(window.location.search);
		let lng = searchParams?.has("lang") ? searchParams.get("lang") : null;

		return lng;
	}

	getPageLanguage() {
		return this.pageLanguage.key;
	}

	canSelectLanguage() {
		return this.languages && this.languages.length > 1;
	}

	changeLanguage() {
		let selectedPageLanguage = this.pageLanguage.key;
		this.$cookies.put("pageLng", selectedPageLanguage);

		let searchParams = Object.fromEntries(new URLSearchParams(window.location.search));
		let queryStringParams = Object.assign(searchParams, { lang: selectedPageLanguage });

		return this.$longWork.execute(this.loadLanguage())
			.then(() => {
				this.$location.search(queryStringParams);
			});
	}
}